import {
  ApplicationConfig,
  mergeApplicationConfig,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { appCommonConfig } from './app.config.common';
import { withBrowserProviders } from '@app/providers/browser.provider';
import { provideMobiUiGoogleMaps } from '@mobi/rwc-ui-components-ng-jslib';
import { provideTerminvereinbarung } from '@mobi/dip-terminvereinbarung-jslib';
import { environment } from '@src/environments/environment';
import { terminvereinbarungBaseUrlInterceptor } from '@app/interceptors/terminvereinbarung-base-url.interceptor';

const onapEnv = environment.lagoonEnv === 'main' ? 'prod' : 'preprod';

const clientConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(withInterceptors([terminvereinbarungBaseUrlInterceptor])),
    withBrowserProviders(),
    provideTerminvereinbarung({ environment: onapEnv }),
    provideMobiUiGoogleMaps({
      apiKey: environment.googleMapsApiKey || '',
      mapId: '937f993ee43b74cf',
    }),
  ],
};

export const appConfig: ApplicationConfig = mergeApplicationConfig(
  appCommonConfig,
  clientConfig
);
